import React from 'react';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover/Popover';
import {formElement} from '../../lib/styles';
import dropDownStyle from '../ui/dropdown-style';
import './rars.css';

const ratings = ['0+', '6+', '12+', '16+', '18+'];

/**
 * Компонент для рейтингов
 */
class Rars extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            open: false,
            value: props.value
        };
    }
    
    onMenuClick = (event) => {
        event.preventDefault();
        if (this.props.disabled) {
            return;
        }
        document.getElementById('rating-select-menu').classList.add('is-active');
        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };
    
    handleRequestClose = () => {
        document.getElementById('rating-select-menu').classList.remove('is-active');
        this.setState({
            open: false,
        });
    };
    
    selectItem = (e) => {
        this.setState({value: e});
        this.handleRequestClose();
        this.props.onChange(e);
    };
    
    render() {
        const classNameLabel = this.props.disabled ? ' is-disabled' : '';
        return (
            <div>
                <small style={{
                    ...formElement.smallTitle,
                    marginTop: 18,
                    marginBottom: 10
                }}>Рейтинг</small>
                <div>
                    <label
                        id="rating-select-menu"
                        onClick={this.onMenuClick}
                        className={`rars--title ${classNameLabel}`}
                        role="presentation"
                    >
                        {this.state.value}
                    </label>
                </div>    
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                    labelStyle={{fontSize: 14, top: 9, ...this.props.labelStyle}}
                    style={{...this.props.style, paddingBottom: 16, marginTop: 10}}
                    floatingLabelText="Рейтинг"
                    value={this.state.value}
                    onRequestClose={this.handleRequestClose}
                >
                    {
                        ratings.map((rating, index) => {
                            return (
                                <MenuItem
                                    style={dropDownStyle.item}
                                    key={index}
                                    value={rating}
                                    primaryText={rating}
                                    onClick={() => this.selectItem(rating)}
                                />
                            );
                        })
                    }
                    {/*</SelectField>*/}
                </Popover>
            </div>
        )
    }
}

export default Rars


// WEBPACK FOOTER //
// src/components/rars/Rars.js